export const _hyphenate = (string) => {
  return string.split(' ').join('-').toLowerCase();
};
